import { Box } from '@pets-ui/Box/Box'
import { Image } from '@pets-ui/Image/Image'
import { PlaceholderNoImage } from '@pets-ui/Placeholder/PlaceholderNoImage'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'
import AiIcon from '../../assets/icons/ai-icon.svg?react'

export interface ButlerItemImageProps {
  productTitle?: ReactNode
  productImgSrc?: string
  productImgWidth?: number
  showAiIcon?: boolean
}

export const ButlerItemImage = (props: ButlerItemImageProps) => {
  const { productImgSrc, productTitle, productImgWidth = 80, showAiIcon = false } = props
  return (
    <Box position="relative" borderRadius={4} overflow="hidden">
      <Image
        src={productImgSrc}
        width={productImgWidth}
        fallback={<PlaceholderNoImage width={productImgWidth} height={productImgWidth} backgroundColor={colors.grey100} noBorder />}
        alt={`${productTitle} image`}
      />
      {showAiIcon && (
        <Box position="absolute" left={0} top={0} display="flex" justifyContent="center" alignItems="center" width={20} height={20} backgroundColor={colors.violet100} borderRadius={2} color={colors.violet600}>
          <AiIcon color={colors.violet600} />
        </Box>
      )}
    </Box>
  )
}
